webpackJsonp([263294834319745],{

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExamplePage = __webpack_require__(6);
	
	var _ExamplePage2 = _interopRequireDefault(_ExamplePage);
	
	var _CodeSample = __webpack_require__(5);
	
	var _CodeSample2 = _interopRequireDefault(_CodeSample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _ExamplePage2.default,
	    { title: 'Selecting multiple days' },
	    _react2.default.createElement(
	      'p',
	      null,
	      'This example shows how to use the component\u2019s state and',
	      ' ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'selectedDays'
	      ),
	      ' to allow the selection of multiple days.'
	    ),
	    _react2.default.createElement(_CodeSample2.default, { name: 'examples/selected-multiple' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-examples-selected-multiple-js-02a9579f46209432ffc2.js